import { render } from "./DocumentPreview.vue?vue&type=template&id=5b8f70b6&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"

import "./DocumentPreview.vue?vue&type=style&index=0&id=5b8f70b6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8f70b6"]])

export default __exports__